.status {
  border-radius: 16px;
  height: 32px;
  min-width: 120px;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.positive {
  background-color: var(--color-feedback-positive-100);
}

.warning {
  background-color: var(--color-feedback-warning-100);
}

.negative {
  background-color: var(--color-feedback-danger-100);
}

.awaiting-justification {
  background-color: var(--feedback-danger-100, var(--color-feedback-danger-100, #FFEAEA));
  color: var(--feedback-danger-600, var(--color-feedback-danger-600, #7A130A));
}

.neutral {
  background-color: var(--color-neutral-200);
}

.info {
  background-color: #DEECFF;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1N0YXR1cyIsInNvdXJjZXMiOlsiU3RhdHVzLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuc3RhdHVzIHtcbiAgYm9yZGVyLXJhZGl1czogMTZweDtcbiAgaGVpZ2h0OiAzMnB4O1xuICBtaW4td2lkdGg6IDEyMHB4O1xuICBwYWRkaW5nOiAwIDE1cHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBnYXA6IDVweDtcbn1cblxuLnBvc2l0aXZlIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY29sb3ItZmVlZGJhY2stcG9zaXRpdmUtMTAwKTtcbn1cblxuLndhcm5pbmcge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jb2xvci1mZWVkYmFjay13YXJuaW5nLTEwMCk7XG59XG5cbi5uZWdhdGl2ZSB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWNvbG9yLWZlZWRiYWNrLWRhbmdlci0xMDApO1xufVxuXG4uYXdhaXRpbmctanVzdGlmaWNhdGlvbiB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWZlZWRiYWNrLWRhbmdlci0xMDAsIHZhcigtLWNvbG9yLWZlZWRiYWNrLWRhbmdlci0xMDAsICNGRkVBRUEpKTtcbiAgY29sb3I6IHZhcigtLWZlZWRiYWNrLWRhbmdlci02MDAsIHZhcigtLWNvbG9yLWZlZWRiYWNrLWRhbmdlci02MDAsICM3QTEzMEEpKTtcbn1cblxuLm5ldXRyYWx7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtMjAwKTtcbn1cblxuLmluZm8ge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjREVFQ0ZGO1xufVxuIl19 */